import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'app-emop-api',
  templateUrl: './emop-api.component.html',
  styleUrls: ['./emop-api.component.scss']
})

export class EmopApiComponent implements OnInit {
  @Input() titleName: string;
  @Input() api = [];
  constructor() { }

  ngOnInit(): void {
  }

}
